module.exports = __webpack_public_path__ + "static/city-never-sleeps-21815734f2c58c6edf08fff234e02c70.jpg";